import formatMessage from 'format-message'

const MAX_RETRIES = 5

export const normalizeSessionData = (data) => ({
  documentId: data.document_id,
  isAnnotatable: !!data.annotations && data.annotations.permissions.includes('readwrite'),
  showAnnotations: !!data.annotations && data.annotations.permissions.includes('read'),
  userId: data.annotations && data.annotations.user_id,
  session: data,
  data: data[data.viewer],
})

export function loadSession(accessToken, attempts = 0) {
  if (!accessToken) {
    const errorMessage = formatMessage(
      'Document viewing session is expired or invalid.<br />Please try again.',
    )
    throw new Error(errorMessage)
  }
  if (window.DocViewer && window.DocViewer.sessionData) {
    return Promise.resolve(window.DocViewer.sessionData)
  }

  return fetch(`/1/sessions/${accessToken}`)
    .then((response) => {
      if (response.ok) {
        return response.json()
      } else if (response.status === 410) {
        throw new Error(formatMessage('document has been deleted'))
      }
      throw new Error(
        formatMessage(
          'Error while processing \
        or retrieving the document',
        ),
      )
    })
    .then((data) => {
      if (data.retry_after && data.error) {
        // don't infinitely retry if the document is still processing
        if (attempts < MAX_RETRIES) {
          return new Promise((resolve) => {
            setTimeout(() => {
              return resolve(loadSession(accessToken, attempts + 1))
            }, data.retry_after * 1000)
          })
        } else {
          console.error(data.error)
          throw new Error(formatMessage('Document is still processing.<br />Please try again.'))
        }
      }

      if (!data.retry_after && data.error) {
        console.error(data.error)

        let errorMessage = formatMessage('Something went wrong viewing that document.')
        if (data.error === 'invalid_session') {
          errorMessage = formatMessage(
            'Document viewing session is expired or invalid.<br />Please try again.',
          )
        } else if (data.error === 'error_converting_document') {
          errorMessage = formatMessage(
            'Document could not be converted.<br />Please download it instead.',
          )
        }

        throw new Error(errorMessage)
      }

      return data
    })
}
